import { render } from "./SmallViewResult.vue?vue&type=template&id=2bbbf8ca&scoped=true"
import script from "./SmallViewResult.vue?vue&type=script&lang=js"
export * from "./SmallViewResult.vue?vue&type=script&lang=js"

import "./SmallViewResult.vue?vue&type=style&index=0&id=2bbbf8ca&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbbf8ca"]])

export default __exports__